<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-title>ご本人様確認をしてください</v-card-title>
      <v-card-subtitle>
        ご登録のEmailアドレス宛に、ご本人様確認のためのメッセージをお送りしました。指示に従って、サインアップを完了してください。
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            この画面を
            <a href="/">閉じる</a>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'

const userStore = createNamespacedHelpers('user')

export default {
  components: { SeaPlusNavIcon, AccumulateNavButton },
  data: () => ({
    isProcessing: false
  }),
  computed: {
    plan() {
      return this.$route.query.plan
    }
  },
  methods: {
    ...userStore.mapActions(['updateUser'])
  }
}
</script>
